<template >
  <article class="accessIndex" v-if="loaded">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
              Plan referidos
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <div
              class="buttom_reload"
              @click="pagination_query=false;filterInvitations(true);date_available=false;"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <div class="table_card__body">
        <div class="accessIndex__general_info states_conventions__container">
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot sended"></div>
            <p class="states_conventions__item--text">Enviadas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot register"></div>
            <p class="states_conventions__item--text">Registradas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot joined"></div>
            <p class="states_conventions__item--text">Ingresadas</p>
          </div>
          <div class="states_conventions__item">
            <div class="states_conventions__item--dot expired"></div>
            <p class="states_conventions__item--text">Vencidas</p>
          </div>
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :items="invitations"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.user }}</td>
          <td>{{ props.item.in_date }}</td>
          <td>{{ props.item.user_destiny }}</td>
          <td class="accessIndex__state_colors">
            <div class="accessIndex__state_colors--container">
              <div v-if="'USED||CREATED||READY_FOR_USE'.includes(props.item.state)"class="accessIndex__state_colors--green_color"></div>
              <div v-if="'USED||READY_FOR_USE'.includes(props.item.state)" class="accessIndex__state_colors--purple_color"></div>
              <div v-if="'USED'.includes(props.item.state)" class="accessIndex__state_colors--blue_color"></div>
              <!-- <div class="accessIndex__state_colors--red_color"></div> -->
            </div>
          </td>
        </template>
      </v-data-table>
      </div>
      <div class="table_card__footer" v-if="invitations.length>0&& pages > 1">
        <div class="accessIndex__pagination">
          <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
          <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
          <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
          <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      invitations: [],
      loaded: false,
      newemail:'',
      headers: [
        {text:'Usuario origen', value: 'user'},
        {text:'Fecha de envío', value: 'in_date'},
        {text:'Usuario destino', value: 'user_destiny'},
        {text:'Estado', value: 'state'}
      ],
      months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"]

    }
  },
  watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterInvitations(false);

       }

       }
    },
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months[index];
        datex=sections.join(" ");
        return datex;
    },
    monthEarlier(){
      var datex=new Date();
      datex.setMonth(datex.getMonth() - 1);
      return datex.toISOString().substr(0, 10);
    },
    filterInvitations(defaultOption,dates){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;
      var initialDate=this.monthEarlier();
      var lastDate=new Date().toISOString().substr(0, 10);
      if(!defaultOption){
        var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' };
          if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
            this.datePickerFirstClick=true;
            this.date = this.modifyDateFormatToStatus(object.date_from);
            this.date2 = this.modifyDateFormatToStatus(object.date_to);
          }
          initialDate=this.date;
          lastDate=this.date2;
      }
      else{
        this.date= this.monthEarlier();
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
      }
      try {
        this.$http.get('invitations/index',{
          params:{
            type: 'referrals',
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
             page:this.pagination.page
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          this.invitations= [];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          var temp=response.body.data;

          for (var i=0;i<temp.length;i++) {


            this.invitations.push({
              user:temp[i].user,
              in_date:this.dateFormat(this.$moment(temp[i].date).format(" MM/DD/YYYY")),
              user_destiny:temp[i].email,
              state: temp[i].state
            })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          console.table(response.body.data)
          this.date_available=true;
          this.loaded = true;

        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }

  },
  mounted(){
    this.date= this.monthEarlier();
     // this.pagination.rowsPerPage=12;
    this.filterInvitations(true);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/Referrals.vue